module.exports = __webpack_public_path__ + "img/neo-patentati.dfa09b52.webp";